import { createRoot, Root } from "react-dom/client";
import { DayscheduleWidget } from "./widget";

type PopupOptions = {
  url: string;
  color?: {
    primary?: string;
    secondary?: string;
  };
};

let popupRoot: Root | null = null;
let container: HTMLElement | null = null;

function createPopup(options: PopupOptions) {
  // Avoid duplicate container
  if (!container) {
    container = document.createElement("div");
    container.id = "ds-popup-container";
    document.body.appendChild(container);
  }

  const close = () => {
    if (popupRoot) {
      popupRoot.unmount();
      popupRoot = null;
    }
    if (container) {
      container.remove();
      container = null;
    }
  };

  popupRoot = createRoot(container);

  popupRoot.render(
    <div
      style={{
        position: "fixed",
        inset: "0",
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: "1rem",
      }}
      onClick={close}
    >
      <div
        style={{
          position: "relative",
          borderRadius: 12,
          width: "100%",
          maxWidth: "1250px",
          height: "80%",
          maxHeight: "auto",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Widget */}
        <div style={{ flex: 1, overflow: "auto" }}>
          <DayscheduleWidget
            url={options.url}
            options={JSON.stringify(options)}
            popup={true}
            onClose={close}
          />
        </div>
      </div>
    </div>
  );

  return { close };
}

export { createPopup as initPopupWidget };
